import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(process.env.REACT_APP_SUPABASE_URL!, process.env.REACT_APP_SUPABASE_KEY!);
  
export async function insertGalleryGenerationResult(uuid: string) {
    await supabase.from('gallery_generation_result').insert({
        uuid: uuid,
    });
}